// worldCountries.js
// (1 Nov 2026, decision 168) The countries list on the History page: a standard world
// list (UN members, observers and common territories, plus the four nations of the
// United Kingdom), each with its region, for choosing the next country alphabetically.
// Regions: Africa, Asia (the Middle East included), Caribbean, Central America, Europe,
// North America, Oceania, South America. "sort" files a name under another letter
// (North and South Korea under K).

const R = (region, names) => names.map((n) => (typeof n === 'string' ? { name: n, region } : { ...n, region }));

export const WORLD_COUNTRIES = [
  ...R('Africa', [
    'Algeria', 'Angola', 'Benin', 'Botswana', 'Burkina Faso', 'Burundi', 'Cameroon', 'Cape Verde',
    'Central African Republic', 'Chad', 'Comoros', 'Congo', 'Democratic Republic of the Congo',
    'Djibouti', 'Egypt', 'Equatorial Guinea', 'Eritrea', 'Eswatini', 'Ethiopia', 'Gabon', 'Gambia',
    'Ghana', 'Guinea', 'Guinea-Bissau', 'Ivory Coast', 'Kenya', 'Lesotho', 'Liberia', 'Libya',
    'Madagascar', 'Malawi', 'Mali', 'Mauritania', 'Mauritius', 'Morocco', 'Mozambique', 'Namibia',
    'Niger', 'Nigeria', 'Réunion', 'Rwanda', 'São Tomé and Príncipe', 'Senegal', 'Seychelles',
    'Sierra Leone', 'Somalia', 'South Africa', 'South Sudan', 'Sudan', 'Tanzania', 'Togo', 'Tunisia',
    'Uganda', 'Zambia', 'Zimbabwe',
  ]),
  ...R('Asia', [
    'Afghanistan', 'Armenia', 'Azerbaijan', 'Bahrain', 'Bangladesh', 'Bhutan', 'Brunei', 'Cambodia',
    'China', 'Georgia', 'Hong Kong', 'India', 'Indonesia', 'Iran', 'Iraq', 'Israel', 'Japan', 'Jordan',
    'Kazakhstan', 'Kuwait', 'Kyrgyzstan', 'Laos', 'Lebanon', 'Macau', 'Malaysia', 'Maldives',
    'Mongolia', 'Myanmar', 'Nepal', { name: 'North Korea', sort: 'Korea, North' }, 'Oman', 'Pakistan',
    'Palestine', 'Philippines', 'Qatar', 'Saudi Arabia', 'Singapore', { name: 'South Korea', sort: 'Korea, South' },
    'Sri Lanka', 'Syria', 'Taiwan', 'Tajikistan', 'Thailand', 'Timor-Leste', 'Turkey', 'Turkmenistan',
    'United Arab Emirates', 'Uzbekistan', 'Vietnam', 'Yemen',
  ]),
  ...R('Caribbean', [
    'Antigua and Barbuda', 'Aruba', 'Bahamas', 'Barbados', 'Cayman Islands', 'Cuba', 'Curaçao',
    'Dominica', 'Dominican Republic', 'Grenada', 'Guadeloupe', 'Haiti', 'Jamaica', 'Martinique',
    'Puerto Rico', 'Saint Kitts and Nevis', 'Saint Lucia', 'Saint Vincent and the Grenadines',
    'Trinidad and Tobago',
  ]),
  ...R('Central America', [
    'Belize', 'Costa Rica', 'El Salvador', 'Guatemala', 'Honduras', 'Nicaragua', 'Panama',
  ]),
  ...R('Europe', [
    'Albania', 'Andorra', 'Austria', 'Belarus', 'Belgium', 'Bosnia and Herzegovina', 'Bulgaria',
    'Croatia', 'Cyprus', 'Czech Republic', 'Denmark', 'England', 'Estonia', 'Faroe Islands', 'Finland',
    'France', 'Germany', 'Gibraltar', 'Greece', 'Guernsey', 'Hungary', 'Iceland', 'Ireland',
    'Isle of Man', 'Italy', 'Jersey', 'Kosovo', 'Latvia', 'Liechtenstein', 'Lithuania', 'Luxembourg',
    'Malta', 'Moldova', 'Monaco', 'Montenegro', 'Netherlands', 'North Macedonia', 'Northern Ireland',
    'Norway', 'Poland', 'Portugal', 'Romania', 'Russia', 'San Marino', 'Scotland', 'Serbia',
    'Slovakia', 'Slovenia', 'Spain', 'Sweden', 'Switzerland', 'Ukraine', 'United Kingdom',
    'Vatican City', 'Wales',
  ]),
  ...R('North America', ['Bermuda', 'Canada', 'Greenland', 'Mexico', 'United States']),
  ...R('Oceania', [
    'Australia', 'Fiji', 'French Polynesia', 'Kiribati', 'Marshall Islands', 'Micronesia', 'Nauru',
    'New Caledonia', 'New Zealand', 'Palau', 'Papua New Guinea', 'Samoa', 'Solomon Islands', 'Tonga',
    'Tuvalu', 'Vanuatu',
  ]),
  ...R('South America', [
    'Argentina', 'Bolivia', 'Brazil', 'Chile', 'Colombia', 'Ecuador', 'French Guiana', 'Guyana',
    'Paraguay', 'Peru', 'Suriname', 'Uruguay', 'Venezuela',
  ]),
];

// Other names a History row may use for a country in the list (lower case).
export const COUNTRY_ALIASES = {
  usa: 'United States', 'u.s.a.': 'United States', 'united states of america': 'United States', america: 'United States', us: 'United States',
  uk: 'United Kingdom', 'great britain': 'United Kingdom', britain: 'United Kingdom',
  holland: 'Netherlands', 'the netherlands': 'Netherlands',
  czechia: 'Czech Republic', burma: 'Myanmar', "côte d'ivoire": 'Ivory Coast', "cote d'ivoire": 'Ivory Coast',
  türkiye: 'Turkey', turkiye: 'Turkey', 'east timor': 'Timor-Leste', swaziland: 'Eswatini',
  macedonia: 'North Macedonia', 'cabo verde': 'Cape Verde', 'the bahamas': 'Bahamas', 'the gambia': 'Gambia',
  'korea, north': 'North Korea', 'korea, south': 'South Korea', korea: 'South Korea',
  'republic of the congo': 'Congo', 'congo-brazzaville': 'Congo', drc: 'Democratic Republic of the Congo',
  'congo-kinshasa': 'Democratic Republic of the Congo', 'dr congo': 'Democratic Republic of the Congo',
  'vatican': 'Vatican City', 'holy see': 'Vatican City', 'viet nam': 'Vietnam', persia: 'Iran',
  'sao tome and principe': 'São Tomé and Príncipe', curacao: 'Curaçao', reunion: 'Réunion',
  uae: 'United Arab Emirates', 'emirates': 'United Arab Emirates', 'ireland (republic)': 'Ireland',
  'republic of ireland': 'Ireland', comores: 'Comoros', 'comoros islands': 'Comoros', 'eire': 'Ireland', 'hong kong sar': 'Hong Kong', macao: 'Macau',
};
